export Form from './Form';



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/owner/components/index.js